import { useState } from 'react';
import { useAppDispatch } from 'src/hooks/redux';
import { updateNoteProspect } from 'src/redux/prospects/prospects.thunks';
import { Prospect } from 'src/redux/prospects/prospects.types';

export const UseHandleProspectsNotes = (prospect: Prospect) => {
    const [value, setValue] = useState(prospect?.note_content || '');
    const [error, setError] = useState(false);
    const [loadingNote, setLoadingNote] = useState(false);
    const dispatch = useAppDispatch();

    const sendNote = () => {
        if (value.length > 500 || error) {
            setError(true);
            return;
        }
        if (loadingNote) return;
        setLoadingNote(!loadingNote);
        dispatch(updateNoteProspect({ prospect_id: prospect.id, note: value }))
            .unwrap()
            .then(() => {
                setTimeout(() => {
                    setLoadingNote(false);
                }, 1000);
            });
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (e.key === 'Enter' && e.ctrlKey) {
            sendNote();
        }
    };

    const handleChange = (event) => {
        setValue(event.target.value);

        const shouldSetValue = event.target.value.length <= 500;

        if (shouldSetValue) {
            setError(false);
        } else {
            setError(true);
        }
    };

    return { value, error, loadingNote, sendNote, handleKeyDown, handleChange };
};
